import {FormError} from './FormError.js'

export class CaptchaStatusGenericFormError extends FormError {}
